import icon1 from '@/assets/static/index/1.webp'
import icon2 from '@/assets/static/index/kefu.png'
import icon3 from '@/assets/static/index/3.webp'
import icon4 from '@/assets/static/index/4.webp'
import timeClubLogo from '@/assets/static/index/tcc_logo_timeclub.png'

export const TIME_CLUB_LOGO = timeClubLogo

export const HOME_BENEFITS = [
  { title: '歐行正品保證', image: icon1 },
  { title: '專屬客服', image: icon2 },
  { title: '會員優惠', image: icon3 },
  { title: '控濕包裝', image: icon4 }
]

export const CLUB_BENEFITS = [
  { text: '歐行正品保證', image: icon1, key: 'authentic' },
  { text: '專屬客服', image: icon2, key: 'service' },
  { text: '會員優享', image: icon3, key: 'member' },
  { text: '控濕包裝', image: icon4, key: 'humidity' }
]
